import type {
  ProjectWorkspaceFileActorDto,
  ProjectWorkspaceFileActivityKind,
  ProjectWorkspaceFileCategory,
} from './project-workspace-file.js';

export const ProjectCommentTargetKind = {
  MILESTONE: 'milestone',
  WORKSPACE_FILE: 'workspace_file',
} as const;

export type ProjectCommentTargetKind =
  (typeof ProjectCommentTargetKind)[keyof typeof ProjectCommentTargetKind];

export const ProjectCommentTargetKindValues = Object.values(ProjectCommentTargetKind);

export interface ProjectCommentAuthorDto {
  id: string;
  displayName: string;
}

export interface ProjectCommentDto {
  id: string;
  projectId: string;
  parentId: string | null;
  targetKind: ProjectCommentTargetKind;
  targetId: string;
  body: string;
  author: ProjectCommentAuthorDto;
  createdAt: string;
  deletedAt: string | null;
  replies: ProjectCommentDto[];
}

export interface CreateProjectCommentDto {
  targetKind: ProjectCommentTargetKind;
  targetId: string;
  body: string;
  parentId?: string | null;
  mentionedUserIds?: string[];
}

export type ProjectActivityKind = 'workspace_file' | 'comment';

export type ProjectActivityEventDto =
  | {
      kind: 'workspace_file';
      at: string;
      actor: ProjectWorkspaceFileActorDto;
      fileId: string;
      fileKind: ProjectWorkspaceFileActivityKind;
      category: ProjectWorkspaceFileCategory;
      originalName: string;
    }
  | {
      kind: 'comment';
      at: string;
      actor: ProjectCommentAuthorDto;
      commentId: string;
      parentId: string | null;
      bodySnippet: string;
      targetKind: ProjectCommentTargetKind;
      targetId: string;
    };

export interface ProjectCommentParticipantDto {
  id: string;
  displayName: string;
  email: string;
  accountSide: 'inquirer' | 'supplier';
}

/** Stable key for an anchor: `${targetKind}:${targetId}` */
export function projectCommentAnchorKey(
  targetKind: ProjectCommentTargetKind,
  targetId: string,
): string {
  return `${targetKind}:${targetId}`;
}

export interface ProjectCommentAnchorSummaryDto {
  targetKind: ProjectCommentTargetKind;
  targetId: string;
  lastCommentAt: string;
  totalCount: number;
}

export interface ProjectCommentSummariesDto {
  summaries: Record<string, ProjectCommentAnchorSummaryDto>;
}
